<app-radio-group
	[items]="fileTypesOptions"
	[ngModel]="selectedFileType"
	(ngModelChange)="changeFileType($event)"
	[testHook]="testHooks.SelectedFileTypeRadioGroup"
></app-radio-group>

<app-dropdown
	label="Select order of sections in documents"
	[itemGroups]="[{ items: showFirstOptions }]"
	[ngModel]="selectedFirstOption"
	(onSelect)="onSelectShowFirst($event)"
	class="mt-5 w-96"
	[testHook]="testHooks.SelectOrderOfSectionsInDocumentsDropdown"
></app-dropdown>

<div class="flex flex-col gap-5 w-4/5 lg:w-3/5 mt-7">
	<app-container type="dark" [testHook]="testHooks.Container">
		<div class="flex w-full">
			<h4 class="pr-5 mb-0">Custom receipts</h4>
			<app-button
				btn="primary"
				[icon]="ICON.ADD"
				size="small"
				(click)="addReceipt()"
				[testHook]="testHooks.AddReceiptButton"
				>Add receipt</app-button
			>
		</div>
		<div cdkDropList (cdkDropListDropped)="_dropReceipt($event)">
			<div
				cdkDrag
				*ngFor="let receipt of filteredOrderedReceipts; trackBy: trackByFn"
				class="flex flex-col mt-5 static draggable-list draggable-item items-start"
			>
				<div class="flex flex-1 w-full">
					<div class="flex left-controls items-center">
						<app-icon
							cdkDragHandle
							[icon]="ICON.SORT"
							class="text-grey-light hover:text-grey-darker cursor-pointer draggable-item"
							[testHook]="testHooks.SortIcon"
						></app-icon>
						<app-button
							btn="tertiary"
							[holdable]="true"
							[icon]="ICON.DELETE"
							(onClick)="deleteReceipt(receipt.id)"
							class="mx-3 text-grey-light hover:text-grey-darker"
							[ngClass]="{ invisible: receipt.deletable === false }"
							[testHook]="testHooks.DeleteButton"
						></app-button>
					</div>
					<div class="flex flex-1 flex-col w-full mr-10">
						<app-input
							[ngModel]="receipt.description"
							(debounce)="setReceiptDescription(receipt, $event)"
							[testHook]="testHooks.Input"
						></app-input>
					</div>
					<div class="w-32 flex items-start">
						@if (receipt.calculated) {
							<span class="self-center">Calculated</span>
						} @else {
							<app-input
								type="cents"
								[ngModel]="receipt.amount"
								(debounce)="setReceiptAmount(receipt, $event)"
								[startIcon]="ICON.DOLLAR"
								textAlign="right"
								[testHook]="testHooks.Input1"
							></app-input>
						}
					</div>
				</div>
			</div>
		</div>
	</app-container>
	<app-container type="dark" [testHook]="testHooks.Container1">
		<div class="flex w-full">
			<h4 class="pr-5 mb-0">Custom payments</h4>
			<app-button
				btn="primary"
				[icon]="ICON.ADD"
				size="small"
				(click)="addPayment()"
				[testHook]="testHooks.AddPaymentButton"
				>Add payment</app-button
			>
		</div>
		<div cdkDropList (cdkDropListDropped)="_dropPayment($event)">
			<div
				cdkDrag
				*ngFor="let payment of filteredOrderedPayments; trackBy: trackByFn"
				class="flex flex-col mt-5 static draggable-list draggable-item items-start"
			>
				<div class="flex flex-1 w-full">
					<div class="flex left-controls items-center">
						<app-icon
							cdkDragHandle
							[icon]="ICON.SORT"
							class="text-grey-light hover:text-grey-darker cursor-pointer draggable-item"
							[testHook]="testHooks.SortIcon1"
						></app-icon>
						<app-button
							btn="tertiary"
							[holdable]="true"
							[icon]="ICON.DELETE"
							(onClick)="deletePayment(payment.id)"
							class="mx-3 text-grey-light hover:text-grey-darker"
							[ngClass]="{ invisible: payment.deletable === false }"
							[testHook]="testHooks.DeleteButton1"
						></app-button>
					</div>
					<div class="flex flex-1 flex-col w-full mr-10">
						<app-input
							[ngModel]="payment.description"
							(debounce)="setPaymentDescription(payment, $event)"
							[testHook]="testHooks.Input2"
						></app-input>
					</div>
					<div class="w-32 flex items-start">
						@if (payment.calculated) {
							<span class="self-center">Calculated</span>
						} @else {
							<app-input
								type="cents"
								[ngModel]="payment.amount"
								(debounce)="setPaymentAmount(payment, $event)"
								[startIcon]="ICON.DOLLAR"
								textAlign="right"
								[testHook]="testHooks.Input3"
							></app-input>
						}
					</div>
				</div>
			</div>
		</div>
	</app-container>
</div>
